import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "auto",
    maxHeight: 300,
  },
  applyFilter: {
    backgroundColor: "#f47c21",
    bottom: 0,
    zIndex: 1,
    position: "sticky",
    lineHeight: "35px",
    display: "flex",
    justifyContent: "center",
    padding: 0,
  },
  menuList: {
    paddingBottom: 0,
  },
  MuiListItemDense: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "flex",
    alignItems: "centre",
    margin: "4px 0px",
    "& .MuiCheckbox-root": {
      padding: "0 !important",
      marginRight: "4px",
    },
    "& .MuiListItemText-root.MuiListItemText-dense": {
      margin: "0",
    },
  },
  searchWrapper: {
    padding: "4px 2px",
  },
  textDecoration: {
    wordSpacing: -1,
  },
}));

export const listDetailsBySource = {
  operator: {
    height: 150,
    itemSize: 40,
  },
  city: {
    height: 140,
    itemSize: 30,
  },
  operationType: {
    height: 95,
    itemSize: 30,
  },
};

export const useMobileBarStyles = makeStyles(() => ({
  root: {
    width: "100%",
    zIndex: 3,
    boxShadow: "0px 6px 24.3px 2.7px rgba(0, 0, 0, 0.15)",
  },
  stickToBottom: {
    height: "auto",
    position: "fixed",
    bottom: 0,
  },
  "@media (max-width:768px)": {
    root: {
      "& .MuiAppBar-colorPrimary": {
        backgroundColor: "#000000",
        overflowX: "auto",
        whiteSpace: "nowrap",
      },
    },
  },
}));
